import { Link } from "react-router-dom";
import ContactForm from './ContactForm'
import Icons from "../../myIcon/Icons";

export default function Contact() {
  return (
    <>
    <div className="contactpage header-gap">
        <div className="container">
            <div className="row">

                <div className="col-lg-6 col-sm-6">
                    <div className="contact-detail">
                        <h1 className="heading">Contact Us</h1>
                        <p>We are open from Monday to Saturday / 10:00 AM - 07:00 PM</p>
                        
                        <label>Gurugram</label>
                        <p>D-43, 1st Floor, Sushant Lok III Extension, Sector-57, Gurgaon, Haryana - 122011</p>
                        
                        <label>Bahadurgarh</label>
                        <p>2nd Floor, SCO No 2 and 3, Omaxe City, Main Entrance, Sector-15, Bahadurgarh, Haryana - 124507</p>

                        <label>Panipat</label>
                        <p>SCO No-112A, TDI City, Panipat, Near Toll Plaza, Haryana - 132103</p>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-6">
                    <ContactForm/>
                </div>

            </div>
        </div>
    </div>


    <div className="contact-career">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <div className="concareer-head">
                        <div>
                            <h2 className="heading">For any query and complaint, </h2>
                            <h3 className="heading">please contact us on</h3>
                        </div>
                        <ul>
                            <li><Link to="tel:+91-8397000603">+91-8397000603</Link></li>
                            <li><Link to="mailto:info@saysha.in">info@saysha.in</Link></li>
                        </ul>
                    </div>
                    <img src="/image/contact-work.webp" loading="lazy" className="img-responsive wow animate__animated animate__slideInUp" data-wow-duration="1.1s" data-wow-delay="0.2s" alt="contact"/>
                </div>

            </div>
        </div>
    </div>
    </>
  )
}
